import navigationTitles from '@/utils/navigationTitles';

export default [{
  path: '/auth',
  component: () => import('@/layouts/AuthLayout'),
  meta: {
    bodyClass: 'layout-auth', // Used for Intercom
  },
  children: [{
    path: 'signin',
    name: 'AuthSignIn',
    component: () => import('@/views/auth/AuthSignIn'),
  }, {
    path: 'create',
    name: 'AuthSignUp',
    component: () => import('@/views/auth/AuthSignUp'),
  }, {
    path: 'reset-password',
    name: 'AuthResetPasswordSendEmail',
    component: () => import('@/views/auth/AuthResetPasswordSendEmail'),
    props: true,
  }, {
    path: 'set-new-password',
    name: 'AuthResetPasswordSetPassword',
    component: () => import('@/views/auth/AuthResetPasswordSetPassword'),
  }, {
    path: 'account-management',
    name: 'AccountManagement',
    component: () => import('@/views/auth/AuthManagement'),
  }, {
    path: '',
    redirect: {
      name: 'Dashboard',
    },
  }],
}, {
  path: '/event',
  component: () => import('@/layouts/AppLayout'),
  meta: {
    requiresAuth: true,
    bodyClass: 'layout-app',
  },
  children: [{
    path: 'create',
    name: 'EventCreate',
    component: () => import('@/views/event/EventCreate'),
    meta: { defaultBaseNavigationTitle: navigationTitles.event.create },
  }, {
    path: ':eventID',
    name: 'EventDetails',
    component: () => import('@/views/event/EventDetails'),
    props: true,
    meta: { noBaseTitleHandling: true, noFooter: true },
  }, {
    path: ':eventID/edit',
    name: 'EventUpdate',
    props: true,
    component: () => import('@/views/event/EventUpdate'),
    meta: { defaultBaseNavigationTitle: navigationTitles.event.update, noBaseTitleHandling: true, noFooter: true },
  }, {
    path: ':eventID/upgrade',
    name: 'EventUpgrade',
    props: true,
    component: () => import('@/views/event/EventUpgrade'),
    meta: { noBaseTitleHandling: true },
  }, {
    path: '',
    redirect: {
      name: 'EventDetails',
    },
  }],
},
// {
// path: '/experimental',
// component: () => import('@/layouts/DefaultLayout'),
// meta: {
//   requiresAuth: true,
//   bodyClass: 'layout-default',
// },
// children: [{
//   path: '',
//   name: 'ExperimentalTheme',
//   component: () => import('@/views/experimental/ExperimentalTheme'),
// }, {
//   path: '*',
//   redirect: {
//     name: 'ExperimentalTheme',
//   },
// }],
// },
{
  path: '/',
  component: () => import('@/layouts/AppLayout'),
  meta: {
    requiresAuth: true,
    bodyClass: 'layout-app',
  },
  children: [{
    path: 'dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard'),
    meta: { defaultBaseNavigationTitle: navigationTitles.dashboard },
  }, {
    path: 'user-profile',
    name: 'UserProfile',
    component: () => import('@/views/UserProfile'),
    meta: { defaultBaseNavigationTitle: navigationTitles.accountDetails },
  }, {
    path: 'subscription-plans',
    name: 'SubscriptionPlans',
    component: () => import('@/views/SubscriptionPlans'),
    meta: { defaultBaseNavigationTitle: navigationTitles.subscriptionPlans },
  }, {
    path: 'team-management',
    name: 'TeamManagement',
    component: () => import('@/views/TeamManagement'),
    meta: { defaultBaseNavigationTitle: navigationTitles.teamManagement },
  }, {
    path: '',
    redirect: {
      name: 'Dashboard',
    },
  }],
}, { // Always leave this as last one
  path: '*',
  component: () => import('@/views/error/Error404'),
}];
